document.addEventListener("DOMContentLoaded", function() {
    const hiddenBenefitTableRows = document.querySelectorAll(".hidden-benefit-table-row");
    const targetNode = document.querySelector("div[data-lion-tier-benefits-compare]");
    
    if (!targetNode || !hiddenBenefitTableRows.length) return;
    
    let updateTimeout;
    
    const displayOtherTextInBenefitTable = () => {
        const benefitTableRows = targetNode.querySelectorAll(".lion-tier-benefits-compare__row");
        
        if (benefitTableRows.length === 0) return;
        
        for (const hiddenRow of hiddenBenefitTableRows) {
            const rowTitle = hiddenRow.children[0]?.innerText?.trim();
            if (!rowTitle) continue;
            
            for (const benefitRow of benefitTableRows) {
                const benefitTitle = benefitRow.children[0]?.innerText?.trim();
                
                if (benefitTitle === rowTitle) {
                    for (let i = 1; i <= 3; i++) {
                        const cell = benefitRow.children[i];
                        const hiddenText = hiddenRow.children[i]?.innerText?.trim();
                        
                        if (cell) {
                            if (hiddenText) {
                                cell.innerHTML = hiddenText;
                                cell.classList.remove('lion-tier-benefits-compare__benefit-status--enabled');
                            } else {
                                cell.innerHTML = '';
                                cell.classList.remove('lion-tier-benefits-compare__benefit-status--enabled');
                            }
                        }
                    }
                    break;
                }
            }
        }
    };
    
    const scheduleUpdate = () => {
        clearTimeout(updateTimeout);
        updateTimeout = setTimeout(displayOtherTextInBenefitTable, 100);
    };
    
    const observer = new MutationObserver(function(mutationsList) {
        for (let mutation of mutationsList) {
            if (mutation.type === 'childList') {
                scheduleUpdate();
            }
        }
    });
    
    observer.observe(targetNode, { childList: true, subtree: true });
});
